import logger from './logger';

const isLink = (el) => {
  const isElementWithHref = el?.hasAttribute('href');
  const isLinkElement = el?.tagName?.toLowerCase() === 'a';

  return Boolean(isElementWithHref && isLinkElement);
};

const elementClickedListener = () => {
  const idAttribute = 'data-logger-element-id';
  const elements = [...document.querySelectorAll(`[${idAttribute}]`)];

  // refactor to use event delegation when performance becomes a problem
  elements.forEach((el) => {
    const { textContent } = el;
    if (!el.dataset) {
      return;
    }
    const { loggerElementLabel, loggerElementId } = el.dataset;
    const label = loggerElementLabel || textContent;
    const elementId = loggerElementId;

    // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track-link
    // if an element is a link we want to use the trackLink method to ensure that the event is tracked
    // before the page is redirected to another page
    if (isLink(el)) {
      logger.bindLinkTracking(el, { label, elementId });
      return;
    }

    // let the page_view component set the page on the logger
    // so we don't have to send it with a button click
    el.addEventListener('click', () =>
      logger.trackElementClicked({ label, elementId })
    );
  });
};

export default elementClickedListener;
